import React from 'react';
import { useAuth } from '../context/AuthContext';
import AntiguedadSaldos, { descargarAntiguedad } from '../components/AntiguedadSaldos';
import SelectorMoneda, { useVistaMoneda } from '../components/reportes/SelectorMoneda';
import Exportar from '../components/reportes/Exportar';
import EncabezadoImpresion from '../components/reportes/EncabezadoImpresion';
import BotonAyuda from '../components/BotonAyuda';

// Antigüedad de cuentas por pagar (#101): reporte aparte de la pantalla
// Cuentas por pagar, que es la lista factura por factura con la agenda.
export default function ReporteAntiguedadPorPagar() {
  const { empresaActiva, empresaActivaNombre } = useAuth();
  const [verEn, setVerEn] = useVistaMoneda();

  return (
    <div className="space-y-6">
      <EncabezadoImpresion titulo="Antigüedad de cuentas por pagar" detalle={`Montos en ${verEn}`} />
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between print:hidden">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">
            Antigüedad de cuentas por pagar
            {empresaActivaNombre && <span className="text-slate-400 font-normal"> · {empresaActivaNombre}</span>}
            <BotonAyuda />
          </h1>
          <p className="text-sm text-slate-500 mt-1">Antigüedad de lo que se les debe a los proveedores, contada desde el vencimiento de cada factura.</p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <SelectorMoneda vista={verEn} onChange={setVerEn} />
          <Exportar
            onExcel={() => descargarAntiguedad('/compras', 'excel', verEn)}
            onPdf={() => descargarAntiguedad('/compras', 'pdf', verEn)}
          />
        </div>
      </div>

      <AntiguedadSaldos base="/compras" etiquetaParte="Proveedor" empresaActiva={empresaActiva} verEn={verEn} />
    </div>
  );
}
